// The demo signs in through its own gate (demo/runtime.ts); the offline sign-in is never reached.
export class SyncEngine {
  static checkPassword(): boolean {
    return false;
  }
}
